<template>
  <vs-popup class=""
            title="CREATE RAW MATERIAL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(openSaveConfirm)" autocomplete="off">


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="supplier_id" name="supplier_id" rules="required" v-slot="{ errors }">
                <small class="label">Supplier</small>
                <v-select v-on:input="onChangeSupplier"  :clearable="false" name="supplier_id" placeholder="" label="company_name" v-model="form.supplier_id" :reduce="option => option.id" :options="suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.company_name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="manufacturing_site" name="manufacturing_site" rules="required" v-slot="{ errors }">
                <small class="label">Manufacturing Sites</small>
                <v-select multiple  :clearable="false" name="manufacturing_site" placeholder="" label="site_name" v-model="form.manufacturing_site" :reduce="option => option.id" :options="sites" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.site_name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" style="display: none">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="similar_raw_materials" name="similar_raw_materials" rules="" v-slot="{ errors }">
                <small class="label">Similar RM</small>
                <v-select
                  @search="onSearch"
                  :clearable="false" multiple name="formulation_items" placeholder=""
                  label="company_product_code" v-model="form.similar_raw_materials" :reduce="option => option.id"
                  :options="similar_rms" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options">
                    type to search products
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <span>PRODUCT CODE: <strong>{{ option.company_product_code ? `${option.category.prefix}-${option.company_product_code}` : '-' }}</strong></span> <br>
                      <small>PRODUCT NAME : <strong>{{ option.company_product_name || '-' }}</strong></small> <br>
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.category.prefix }} {{ option.company_product_code }}
                    </div>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="supplier_product_code" name="supplier_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Code</small>
                <vs-input v-model="form.supplier_product_code" name="supplier_product_code"  class="w-full required" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="supplier_product_name" name="supplier_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Name</small>
                <vs-input name="supplier_product_name" v-model="form.supplier_product_name"  class="w-full required" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">

            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="alternative_chemical_name" name="alternative_chemical_name" rules="" v-slot="{ errors }">
                <small class="label">Alternative / Chemical Name</small>
                <vs-input name="alternative_chemical_name" v-model="form.alternative_chemical_name"  class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="country_processing" name="country_processing" rules="required" v-slot="{ errors }">
                <small class="label">Country of Processing</small>
                <v-select :filter-by="myFilter" multiple :clearable="false" name="country_processing" placeholder="" label="name" v-model="form.country_processing" :reduce="option => option.id" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="raw_material_stage" name="raw_material_stage" rules="required" v-slot="{ errors }">
                <small class="label">Stage (development,production)</small>
                <v-select name="raw_material_stage" :closeOnSelect="true" v-model="form.raw_material_stage" :options="['production', 'development']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="nominal_code" name="nominal_code" rules="required" v-slot="{ errors }">
                <small class="label">Sage Nominal Code</small>
                <v-select :clearable="false" name="nominal_code" placeholder=""
                          label="name" v-model="form.sage_nominal_code_id" :reduce="option => option.id"
                          :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="is_food_grade" name="is_food_grade" rules="" v-slot="{ errors }">
                <small class="label">Food Grade?</small>
                <vs-switch v-model="form.is_food_grade" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.is_food_grade" vid="is_food_grade_comment" name="is_food_grade_comment" rules="required" v-slot="{ errors }">
                <small class="label">If yes,please specify</small>
                <vs-input type="text" name="is_food_grade_comment" class="w-full" v-model="form.is_food_grade_comment" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider vid="is_compliant_food_law" name="is_compliant_food_law" rules="" v-slot="{ errors }">
                <small class="label">Compliant with General Food Law (Regulation (EC) No 178/2002)</small>
                <vs-switch v-model="form.is_compliant_food_law" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="form.is_compliant_food_law" vid="is_compliant_food_law_comment" name="is_compliant_food_law_comment" rules="required" v-slot="{ errors }">
                <small class="label">If yes,please specify</small>
                <vs-input type="text" name="is_compliant_food_law_comment" class="w-full" v-model="form.is_compliant_food_law_comment" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Additional Information</small>
              <vs-textarea v-model="form.additional_information" />
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      form: {
        is_food_grade:  false,
        is_compliant_food_law: false,
      },
      countryCodes: [],
      sites: [],
      suppliers: [],
      supplierId: '',
      similar_rms: [],
      sage_nominal_codes:[],
    }
  }

export default {
  name: 'CreateRawMaterialWithoutSupplierPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading({
          container: '#popup',
          scale: 0.50
        })
        this.open = true;
        await this.loadCountrCode()
        await this.loadSuppliers()
        await this.getSageNominalCodes()
        // await this.getSimilarRmList()
        this.$vs.loading.close('#popup > .con-vs-loading')
      } catch (error) {
        this.$vs.loading.close('#popup > .con-vs-loading')

      }
    },
    openSaveConfirm() {
      this.open = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Note',
        text: 'Once you save this page the supplier product code and name cannot be changed',
        accept: this.onClickUpdate,
        cancel: this.closeUpdate
      })
    },
    closeUpdate() {
      this.open = true
    },
    async onClickUpdate () {
      const vue = this;
      this.$vs.loading()
       try {
         const payload = this.form
         await SupplierRawMaterialRepository.createRawMaterial(payload)
         this.showSuccessMessage('Raw material created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {

         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    async loadCountrCode() {
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async onChangeSupplier() {
      this.$vs.loading({
        container: '#popup',
        scale: 0.50
      })
      try {
        this.form.manufacturing_site = []
        const {data} = await DropDownRepository.getManufacturingSites(this.form.supplier_id, 1, '', 100, '')
        this.sites =  data.data
      } catch (e) {

      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async loadSuppliers() {
      try {
        const {data} = await DropDownRepository.getApprovedSupplierList()
        this.suppliers =  data.data
      } catch (e) {

      }
    },
    async getSimilarRmList() {
      try {
        const {data} = await SupplierRawMaterialRepository.getRawMaterialList(1, '', 100, '')
        this.similar_rms =  data.data
      } catch (e) {

      }
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = await SupplierRawMaterialRepository.getRawMaterialList(1, `filter[search]=${search}`, 50, '')
      vm.similar_rms = data.data
      loading(false);
    }, 350)
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
